import { render, staticRenderFns } from "./CK_highLights.vue?vue&type=template&id=234f4fc1&"
import script from "./CK_highLights.vue?vue&type=script&lang=js&"
export * from "./CK_highLights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports